import { styled } from '@mui/system';
import { SectionHeading, SectionSubtext } from '../Splash/styles';
import { fontFamilies } from '../../../constants/theme';

export const SectionTitle = styled(SectionHeading)(({ theme }) => ({
  ...theme.typography.heading,
  fontSize: '50px',
  fontFamily: fontFamilies.gotham,
  fontWeight: 400,
  lineHeight: '58px',
  letterSpacing: '-1px',
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: '36px',
    lineHeight: '44px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
    lineHeight: '36px',
  },
}));

export const Subtext = styled(SectionSubtext)(({ theme, marginBottom = '50px' }) => ({
  ...theme.typography.subtext,
  fontFamily: fontFamilies.quicksand,
  fontWeight: 400,
  lineHeight: '32px',
  letterSpacing: '0.15px',
  textAlign: 'center',
  margin: '14px auto auto',
  whiteSpace: 'pre-line',
  marginBottom: marginBottom,
  maxWidth: '1050px',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
    lineHeight: '28px',
    marginBottom: '40px',
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    lineHeight: '24px',
    marginBottom: '30px',
    padding: '0 16px',
  },
}));

export const BottomText = styled(Subtext)(({ theme }) => ({
  margin: '70px auto',
  [theme.breakpoints.down('md')]: {
    margin: '50px auto',
  },
  [theme.breakpoints.down('sm')]: {
    margin: '40px auto',
  },
}));
